export default __webpack_public_path__ + "static/media/dyed-spider-mum.c7fc5b0a.webp";